import React from 'react'
import { IconButton, Icon } from '@material-ui/core'
import Default from '../Default'

export default class extends React.PureComponent {
  render() {
    const checkedIn = this.props
    if (checkedIn === true)
      return (
        <IconButton style={largeIcon}>
          <Icon>check</Icon>
        </IconButton>
      )

    return <Default style={buttonStyle}>チェックイン</Default>
  }
}

const buttonStyle = {
  display: 'block',
  float: 'right',
  padding: '10px 10px',
  borderRadius: '20px',
  background: '#FFFFFF',
  color: 'rgba(169, 177, 181)',
  boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.1)',
  fontSize: '14px',
  fontWeight: 800,
  marginTop: '5px',
}
const largeIcon = {
  transform: 'scale(2.0)',
  display: 'block',
  float: 'right',
  paddingRight: '15px',
}
